export const breakpoints = {
  md: "768px",
  lg: "1440px",
};
